














import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "AiResponsePlaceholder",
  components: { BaseButton, BaseIcon },
});
